import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from '@components/Layout';
import ErrorBoundary from '@components/ErrorBoundary';
import HomePage from '@routes/home';
import CategoryPage from '@routes/category';
import SearchPage from '@routes/search';
import StaticPage from '@routes/static-page';
import GuidePage from '@routes/guide';
import { LanguageProvider } from '@lib/i18n';
import {
  LocaleOrGameRoute,
  LocaleGameRoute,
  LocaleCategoryRoute,
  LocaleSearchRoute,
} from '@components/LocaleWrapper';

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <LanguageProvider>
        <Layout>
          <Routes>
            {/* Base routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/category/:slug" element={<CategoryPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/privacy" element={<StaticPage slug="privacy" />} />
            <Route path="/terms" element={<StaticPage slug="terms" />} />
            <Route path="/dmca" element={<StaticPage slug="dmca" />} />
            <Route path="/guides/:slug" element={<GuidePage />} />

            {/* Locale-prefixed routes (e.g. /vn, /jp/pokerogue, /zh/category/pokemon) */}
            <Route path="/:locale/category/:slug" element={<LocaleCategoryRoute />} />
            <Route path="/:locale/search" element={<LocaleSearchRoute />} />
            <Route path="/:locale/:slug" element={<LocaleGameRoute />} />

            {/* Catch-all: locale homepage (e.g. /vn) OR game page (e.g. /pokerogue) */}
            <Route path="/:slug" element={<LocaleOrGameRoute />} />
          </Routes>
        </Layout>
      </LanguageProvider>
    </ErrorBoundary>
  );
};

export default App;
